//@ts-nocheck
import Router, { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/jha-tab/jha-tab";
import "@banno/jha-wc/src/jha-tab-item/jha-tab-item";
import "@banno/jha-wc/src/cards/jha-card/jha-card";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "./WorkflowGeneralInfoView";
import "./NotificationView";
import "./WorkflowStepsView";
import "./SchedulerView";
import { WorkflowType, FileInfoType, DEFAULT_WORKFLOW_TYPE_ODI } from "../../types/Workflow/WorkflowDataType";
import { Apis } from "../../utils/api-constants";
import { getWorkflowSaveErrorMessage } from "../../utils/getErrorMessage";
import { GlobalVariables, GlobalConstants } from "../../utils/constants";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { fixedEncodeURIComponent, getRequest, postRequest } from "../../utils/jha-fetch";
import { routerConfig } from "../../routers";
import { AppRouters } from "../../utils/app-router";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
import {
    afterGeneralInfoLoad,
    applyWorkflowCancelBaselineDefaults,
    captureWorkflowCancelBaseline,
    isWorkflowCancelDirty,
    resolveGeneralInfoAutoFill,
} from "../../utils/workflow-cancel-dirty";
import Cookies from "js-cookie";
import {
    decryptValue,
    stringComparison,
    getCurrentDateTimeInTimeZone,
    getTimeZoneIdentifier,
} from "../../utils/app-utils";
import { isGeneralInfoTabComplete, syncGeneralInfoValid } from "../../utils/workflow-general-info-valid";
import {
    formatWorkflowSaveProblems,
    workflowSaveInvalidBlankMessage,
} from "../../utils/workflow-save-validation";
import { formatWorkflowSchedulerNow } from "../../utils/datetime-display";
import {
    applyFileLocationAuthTypeIfSftpFtps,
    applyPushSftpAuthTypeToCredentialSourceFileInfo,
    cloneSecretValueOmitAuthType,
    syncStepAuthTypesFromBothFileInfos,
    wizardStepSftpFtpsSecretsComplete,
} from "../../utils/workflow-file-location-secret";
import {
    applyInstitutionUuidOutbound,
    readInstitutionUuidFromStep,
} from "../../utils/workflow-institution-step";
import { resolveWorkflowPathSegment } from "../../utils/workflow-source-location-path";
import { newWorkflowId } from "../../utils/workflow-id";
import { abortWorkflowLoad } from "../../utils/workflow-not-found-message";

@customElement("clone-workflow-tab-view")
export class CloneWorkflowTabView extends routingMixin(LitElement) {
    constructor() {
        super();
    }

    @property()
    activeTab = "page1";

    @property({ reflect: true, attribute: "workflow-id" })
    workflowId = "";
    @property({ attribute: false })
    workflowData = { isClone: false, isEdit: false, isSourceLocationValid: true, isWorkflowNameValid: true };
    @property({ attribute: false })
    filepattern = { TriggerFilePattern: ([] = []), DataFilePattern: ([] = []), isEdit: false, valid: false };
    @property({ attribute: false })
    schedulerData = { isRateDisabled: false, isCronDisabled: true };
    @property()
    sourceFolder: string = "";
    @property()
    bucketName: string = "";
    @property()
    businessUnit: string = "";
    @property()
    sourcePath: string = "";
    @property({ type: Array })
    notification = [{ number: Number, added: Boolean }];
    @property()
    steps = {};
    @property({ type: Boolean })
    workFlowDisable = false;
    @property({ type: Object })
    workflow: WorkflowType = {
        WorkflowName: "",
        sourceLocationPath: "",
        BusinessUnitParticipant: "",
        DataFilePattern: [],
        TriggerFilePattern: [],
        Notification: [],
        status: "",
        Scheduler: {
            SchedulerName: "",
            Description: "",
            Expression: "",
            TimeZone: "",
            StartDate: "",
            StartTime: "",
            EndDate: "",
            EndTime: "",
        },
        workflowType: "",
        workflowSteps: [],
        TransferType: "",
    };
    @property({ type: Object })
    sourceFileInfo: FileInfoType = {};
    @property()
    workflowResponse: any;
    @property({ type: Boolean })
    apiLoading = false;
    @property({ type: Boolean })
    isReadOnlyUser = /readonly/i.test(decryptValue(Cookies.get("userRole")));
    /** ACME-1050: baseline after hydrate — see `workflow-cancel-dirty.ts` (do not latch dirty from tab events). */
    private _cancelBaseline: string | null = null;
    private _giDefaultsFolded = false;
    @property({ type: Boolean })
    isFilePatternValid = this.filepattern.DataFilePattern.length <= 0 && this.filepattern.TriggerFilePattern.length <= 0;
    @property({ type: Boolean })
    isSchedulerValid = this.schedulerData.valid;
    @property({ type: Boolean })
    isWorkflowStepsValid = true;
    @property({ type: Object })
    notificationData = {
        number: 1,
        messageType: "",
        notificationType: "",
        to: "",
        subject: "",
        template: "",
        added: false,
    };
    static get is() {
        return "clone-workflow-tab-view";
    }
    static readonly styles = css`
    #cloneWorkflowTab {
      padding: 24px;
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    jha-card {
      padding: 24px;
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-left: 0px;
      margin-right: 0px;
      overflow: hidden;
    }
    #tabContent {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow-y: scroll;
    }
    #backBtn {
      cursor: pointer;
      margin-right: 10px;
    }
    jha-tab-item > [icon] {
      margin-right: 8px;
      vertical-align: middle;
    }
    jha-icon-circle-checkmark-filled {
      fill: var(--jha-color-success);
    }
    jha-icon-warning-filled {
      fill: var(--jha-color-warning);
    }
  `;
    onSaveWorkflowCustomEvent(e) {
        this.workflowData = e.detail;
    }
    unsavednotificationChanges(e) {
        this.notificationData = e.detail;
    }
    onSaveNotificationCustomEvent(e) {
        this.notification = e.detail;
    }
    onSaveStepsCustomEvent(e) {
        this.steps = e.detail.workflowStepsData;
        this.workflowData.DeleteFiles = e.detail.deleteFiles;

        this.steps.forEach((element) => {
            element.isValidStep = this.validateWorkflowStep(element);
        });
        this.isWorkflowStepsValid = !this.steps.some((y) => y.isValidStep === false);
    }
    onSaveSchedulerEvent(e) {
        this.schedulerData = e.detail;
        this.isSchedulerValid = this.schedulerData.valid;
    }
    async onCloneWorkflowClick() {
        syncGeneralInfoValid(this.workflowData);
        let currentDateTime = null;
        let scheduledDateTime = null;
        if (this.schedulerData.StartDate && this.schedulerData.StartHour && this.schedulerData.StartMinute) {
            scheduledDateTime = new Date(
                `${this.schedulerData.StartDate}T${this.schedulerData.StartHour}:${this.schedulerData.StartMinute}`
            );
            currentDateTime = getCurrentDateTimeInTimeZone(getTimeZoneIdentifier(this.schedulerData.TimeZone));
            currentDateTime.setSeconds(0, 0);
        }
        if (this.workflowData.TransferType == undefined) {
            this.requestUpdate();
            showToast({
                message: formatWorkflowSaveProblems([
                    { label: "Transfer Type", kind: "required", tab: "General Information" },
                ]),
                role: "danger",
                duration: GlobalVariables.TOAST_TIMEOUT,
            });
        } else if (
            stringComparison(this.workflowData.TransferType, "PUSH") &&
            (!this.workflowData.valid || this.filepattern.DataFilePattern.length <= 0 || this.filepattern.TriggerFilePattern.length <= 0)
        ) {
            this.requestUpdate();
            showToast({
                message: workflowSaveInvalidBlankMessage({
                    workflowData: this.workflowData,
                    filepattern: this.filepattern,
                    includeScheduler: false,
                }),
                role: "danger",
                duration: GlobalVariables.TOAST_TIMEOUT,
            });
        } else if (
            stringComparison(this.workflowData.TransferType, "PULL") &&
            (!this.workflowData.valid ||
                this.filepattern.DataFilePattern.length <= 0 ||
                this.filepattern.TriggerFilePattern.length <= 0 ||
                !this.schedulerData.valid)
        ) {
            this.requestUpdate();
            showToast({
                message: workflowSaveInvalidBlankMessage({
                    workflowData: this.workflowData,
                    filepattern: this.filepattern,
                    schedulerData: this.schedulerData,
                    includeScheduler: true,
                }),
                role: "danger",
                duration: GlobalVariables.TOAST_TIMEOUT,
            });
        } else if (this.schedulerData.StartDate != undefined && scheduledDateTime < currentDateTime) {
            const formatedDateTime = formatWorkflowSchedulerNow(this.schedulerData.TimeZone);
            this.apiLoading = false;
            showToast({
                message: `Scheduler start datetime cannot be less than current datetime ${formatedDateTime}`,
                role: "danger",
                duration: GlobalVariables.TOAST_TIMEOUT,
            });
        } else {
            //steps
            if (this.steps.length > 0) {
                let workflowSteps = {
                    FunctionName: "",
                    StepName: "",
                    DeleteSourceFile: false,
                    FileMovePattern: [],
                    DestinationFileInfo: {
                        Name: "",
                        Path: "",
                        LocationType: "",
                        StorageType: "",
                        FileRename: {},
                        BucketRename: "",
                        SecretName: "",
                        SecretValue: {},
                    },
                    SourceFileInfo: {
                        Name: "",
                        Path: "",
                        LocationType: "",
                        StorageType: "",
                        FileRename: {},
                        BucketRename: "",
                        SecretName: "",
                        SecretValue: {},
                    },
                    StepIndex: 0,
                };

                this.workflow.workflowSteps = [];
                if (stringComparison(this.workflowData.TransferType, "PUSH")) {
                    for (let i = 0; i < this.steps.length; i++) {
                        this.workflow.workflowSteps.push(JSON.parse(JSON.stringify(workflowSteps)));
                        this.workflow.workflowSteps[i].StepName = this.steps[i].stepName;
                        this.workflow.workflowSteps[i].FunctionName = this.steps[i].functionName;
                        this.workflow.workflowSteps[i].DeleteSourceFile = stringComparison(this.steps[i].deleteSourceFile, "true") ? true : false;
                        this.workflow.workflowSteps[i].StepIndex = this.steps[i].stepIndex;
                        this.workflow.workflowSteps[i].FileMovePattern = this.steps[i].FileMovePattern;
                        applyInstitutionUuidOutbound(this.workflow.workflowSteps[i], this.steps[i].institutionUuid);
                        if (stringComparison(this.workflow.workflowSteps[i].FunctionName, "filedelete")) {
                            this.workflow.workflowSteps[i].SourceFileInfo.Name = this.steps[i].name;
                            if (this.steps[i].path != undefined || this.steps[i].path != null) {
                                this.workflow.workflowSteps[i].SourceFileInfo.Path = this.steps[i].path;
                            }
                            this.sourceFolder = this.steps[i].name;
                            this.workflow.workflowSteps[i].SourceFileInfo.LocationType = this.steps[i].locationType;
                            this.workflow.workflowSteps[i].SourceFileInfo.StorageType = this.steps[i].storageType;
                            this.workflow.workflowSteps[i].SourceFileInfo.FileRename = this.steps[i].fileRename;
                            this.workflow.workflowSteps[i].SourceFileInfo.BucketRename = this.steps[i].bucketRename;
                            if (this.steps[i].storageType == "azure" || this.steps[i].storageType == "amazons3remote") {
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretName = this.steps[i].secretName;
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                    this.steps[i].secretValue
                                );
                            } else {
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretName = this.steps[i].secretName;
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                    this.steps[i].secretValue
                                );
                            }
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].SourceFileInfo, this.steps[i], "source");
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].DestinationFileInfo, this.steps[i], "destination");
                        } else {
                            this.workflow.workflowSteps[i].DestinationFileInfo.Name = this.steps[i].name;
                            if (this.steps[i].path != undefined || this.steps[i].path != null) {
                                this.workflow.workflowSteps[i].DestinationFileInfo.Path = this.steps[i].path;
                            }
                            this.workflow.workflowSteps[i].DestinationFileInfo.LocationType = this.steps[i].locationType;
                            this.workflow.workflowSteps[i].DestinationFileInfo.StorageType = this.steps[i].storageType;
                            this.workflow.workflowSteps[i].DestinationFileInfo.FileRename = this.steps[i].fileRename;
                            this.workflow.workflowSteps[i].DestinationFileInfo.BucketRename = this.steps[i].bucketRename;

                            if (this.steps[i].storageType == "azure" || this.steps[i].storageType == "amazons3remote") {
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretName = this.steps[i].secretName;
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                    this.steps[i].secretValue
                                );
                            } else {
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretName = this.steps[i].secretName;
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                    this.steps[i].secretValue
                                );
                            }
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].SourceFileInfo, this.steps[i], "source");
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].DestinationFileInfo, this.steps[i], "destination");
                            applyPushSftpAuthTypeToCredentialSourceFileInfo(
                                this.workflow.workflowSteps[i].SourceFileInfo,
                                this.steps[i],
                                this.steps[i].storageType
                            );
                        }
                    }
                } else if (stringComparison(this.workflowData.TransferType, "PULL")) {
                    for (let i = 0; i < this.steps.length; i++) {
                        this.workflow.workflowSteps.push(JSON.parse(JSON.stringify(workflowSteps)));
                        this.workflow.workflowSteps[i].StepName = this.steps[i].stepName;
                        this.workflow.workflowSteps[i].FunctionName = this.steps[i].functionName;
                        this.workflow.workflowSteps[i].DeleteSourceFile = stringComparison(this.steps[i].deleteSourceFile, "true") ? true : false;
                        this.workflow.workflowSteps[i].StepIndex = this.steps[i].stepIndex;
                        this.workflow.workflowSteps[i].FileMovePattern = this.steps[i].FileMovePattern;
                        applyInstitutionUuidOutbound(this.workflow.workflowSteps[i], this.steps[i].institutionUuid);
                        if (
                            stringComparison(this.workflow.workflowSteps[i].FunctionName, "filedownload") ||
                            stringComparison(this.workflow.workflowSteps[i].FunctionName, "filedelete")
                        ) {
                            this.workflow.workflowSteps[i].SourceFileInfo.Name = this.steps[i].name;
                            if (this.steps[i].path != undefined || this.steps[i].path != null) {
                                this.workflow.workflowSteps[i].SourceFileInfo.Path = this.steps[i].path;
                            }
                            this.sourceFolder = this.steps[i].name;
                            this.workflow.workflowSteps[i].SourceFileInfo.LocationType = this.steps[i].locationType;
                            this.workflow.workflowSteps[i].SourceFileInfo.StorageType = this.steps[i].storageType;
                            this.workflow.workflowSteps[i].SourceFileInfo.FileRename = this.steps[i].fileRename;
                            this.workflow.workflowSteps[i].SourceFileInfo.BucketRename = this.steps[i].bucketRename;


                            this.workflow.workflowSteps[i].SourceFileInfo.SecretName = this.steps[i].secretName;
                            this.workflow.workflowSteps[i].SourceFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                this.steps[i].secretValue
                            );
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].SourceFileInfo, this.steps[i], "source");
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].DestinationFileInfo, this.steps[i], "destination");
                        } else {
                            this.workflow.workflowSteps[i].DestinationFileInfo.Name = this.steps[i].name;
                            if (this.steps[i].path != undefined || this.steps[i].path != null) {
                                this.workflow.workflowSteps[i].DestinationFileInfo.Path = this.steps[i].path;
                            }
                            this.workflow.workflowSteps[i].DestinationFileInfo.LocationType = this.steps[i].locationType;
                            this.workflow.workflowSteps[i].DestinationFileInfo.StorageType = this.steps[i].storageType;
                            this.workflow.workflowSteps[i].DestinationFileInfo.FileRename = this.steps[i].fileRename;
                            this.workflow.workflowSteps[i].DestinationFileInfo.BucketRename = this.steps[i].bucketRename;

                            if (this.steps[i].storageType == "azure" || this.steps[i].storageType == "amazons3remote") {
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretName = this.steps[i].secretName;
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                    this.steps[i].secretValue
                                );
                            } else {
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretName = this.steps[i].secretName;
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                    this.steps[i].secretValue
                                );
                            }
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].SourceFileInfo, this.steps[i], "source");
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].DestinationFileInfo, this.steps[i], "destination");
                            applyPushSftpAuthTypeToCredentialSourceFileInfo(
                                this.workflow.workflowSteps[i].SourceFileInfo,
                                this.steps[i],
                                this.steps[i].storageType
                            );
                        }
                    }
                } else if (stringComparison(this.workflowData.TransferType, "PULL")) {
                    for (let i = 0; i < this.steps.length; i++) {
                        this.workflow.workflowSteps.push(JSON.parse(JSON.stringify(workflowSteps)));
                        this.workflow.workflowSteps[i].StepName = this.steps[i].stepName;
                        this.workflow.workflowSteps[i].FunctionName = this.steps[i].functionName;
                        this.workflow.workflowSteps[i].DeleteSourceFile = stringComparison(this.steps[i].deleteSourceFile, "true") ? true : false;
                        this.workflow.workflowSteps[i].StepIndex = this.steps[i].stepIndex;
                        this.workflow.workflowSteps[i].FileMovePattern = this.steps[i].FileMovePattern;
                        applyInstitutionUuidOutbound(this.workflow.workflowSteps[i], this.steps[i].institutionUuid);
                        if (
                            stringComparison(this.workflow.workflowSteps[i].FunctionName, "filedownload") ||
                            stringComparison(this.workflow.workflowSteps[i].FunctionName, "filedelete")
                        ) {
                            this.workflow.workflowSteps[i].SourceFileInfo.Name = this.steps[i].name;
                            if (this.steps[i].path != undefined || this.steps[i].path != null) {
                                this.workflow.workflowSteps[i].SourceFileInfo.Path = this.steps[i].path;
                            }
                            this.sourceFolder = this.steps[i].name;
                            this.workflow.workflowSteps[i].SourceFileInfo.LocationType = this.steps[i].locationType;
                            this.workflow.workflowSteps[i].SourceFileInfo.StorageType = this.steps[i].storageType;
                            this.workflow.workflowSteps[i].SourceFileInfo.FileRename = this.steps[i].fileRename;
                            this.workflow.workflowSteps[i].SourceFileInfo.BucketRename = this.steps[i].bucketRename;

                            if (this.steps[i].storageType == "azure") {
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretName = this.steps[i].secretName;
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                    this.steps[i].secretValue
                                );
                            } else {
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretName = this.steps[i].secretName;
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                    this.steps[i].secretValue
                                );
                            }
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].SourceFileInfo, this.steps[i], "source");
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].DestinationFileInfo, this.steps[i], "destination");
                        } else {
                            this.workflow.workflowSteps[i].DestinationFileInfo.Name = this.steps[i].name;
                            this.workflow.workflowSteps[i].DestinationFileInfo.Path =
                                stringComparison(this.steps[i].storageType, "amazons3") &&
                                    !stringComparison(this.workflow.workflowSteps[i].FunctionName, "unprocessedfilearchive")
                                    ? this.workflowData.BusinessUnitParticipant.concat(this.steps[i].path)
                                    : this.steps[i].path;
                            this.workflow.workflowSteps[i].DestinationFileInfo.LocationType = this.steps[i].locationType;
                            this.workflow.workflowSteps[i].DestinationFileInfo.StorageType = this.steps[i].storageType;
                            this.workflow.workflowSteps[i].DestinationFileInfo.FileRename = this.steps[i].fileRename;
                            this.workflow.workflowSteps[i].DestinationFileInfo.BucketRename = this.steps[i].bucketRename;

                            if (this.steps[i].storageType == "azure" || this.steps[i].storageType == "amazons3remote") {
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretName = this.steps[i].secretName;
                                this.workflow.workflowSteps[i].DestinationFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                    this.steps[i].secretValue
                                );
                            } else {
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretName = this.steps[i].secretName;
                                this.workflow.workflowSteps[i].SourceFileInfo.SecretValue = cloneSecretValueOmitAuthType(
                                    this.steps[i].secretValue
                                );
                            }
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].SourceFileInfo, this.steps[i], "source");
                            applyFileLocationAuthTypeIfSftpFtps(this.workflow.workflowSteps[i].DestinationFileInfo, this.steps[i], "destination");
                        }
                    }
                }
            }
            //notification
            if (this.notification.length > 0) {
                let notifications = {
                    messageType: "",
                    notificationType: "",
                    to: "",
                    subject: "",
                    template: "",
                };
                this.workflow.Notification = [];
                for (let i = 0; i < this.notification.length; i++) {
                    this.workflow.Notification.push(JSON.parse(JSON.stringify(notifications)));
                    this.workflow.Notification[i].to = this.notification[i].to;
                    this.workflow.Notification[i].subject = this.notification[i].subject;
                    this.workflow.Notification[i].messageType = this.notification[i].messageType;
                    this.workflow.Notification[i].notificationType = this.notification[i].notificationType;
                    this.workflow.Notification[i].template = this.notification[i].template;
                }
            } else {
                this.workflow.Notification = null;
            }
            if (this.schedulerData != undefined) {
                this.workflow.Scheduler = this.workflow.Scheduler ?? {};
                this.workflow.Scheduler.Description = this.schedulerData.Description;
                this.workflow.Scheduler.Expression = this.schedulerData.Expression;
                this.workflow.Scheduler.StartDate = this.schedulerData.StartDate;
                this.workflow.Scheduler.StartTime = this.schedulerData.StartTime;
                if (this.schedulerData.StartHour != undefined) {
                    this.workflow.Scheduler.StartTime = `${this.schedulerData.StartHour}:${this.schedulerData.StartMinute}`;
                }
                this.workflow.Scheduler.EndDate = this.schedulerData.EndDate;
                this.workflow.Scheduler.EndTime = this.schedulerData.EndTime;
                this.workflow.Scheduler.TimeZone = this.schedulerData.TimeZone;
            } else {
                this.workflow.Scheduler = null;
            }
            //workflow
            if (!this.workflowData.WorkflowId) {
                this.workflowData.WorkflowId = newWorkflowId();
            }
            const pathSegment = resolveWorkflowPathSegment(
                this.workflowData.WorkflowId,
                this.workflowData.WorkflowName,
            );
            this.workflow.WorkflowId = this.workflowData.WorkflowId;
            this.workflow.BusinessUnitParticipant = this.workflowData.BusinessUnitParticipant;
            this.workflow.sourceLocationPath = stringComparison(this.workflowData.TransferType, "pull")
                ? "/" + pathSegment + "/"
                : this.workflowData.sourceLocationPath;
            this.workflow.TriggerFilePattern = stringComparison(this.workflowData.TransferType, "push")
                ? this.filepattern.TriggerFilePattern
                : this.filepattern.TriggerFilePattern.map((element) => "\\".concat("/*", element.replace("/", "\\/")));
            this.workflow.DataFilePattern = stringComparison(this.workflowData.TransferType, "push")
                ? this.filepattern.DataFilePattern
                : this.filepattern.DataFilePattern.map((element) => "\\".concat("/*", element.replace("/", "\\/")));
            this.workflow.TransferType = this.workflowData.TransferType;
            this.workflow.WorkflowName = this.workflowData.WorkflowName;
            this.workflow.status = "inactive";
            this.workflow.workflowType = DEFAULT_WORKFLOW_TYPE_ODI;
            this.workflow.DeleteFiles = stringComparison(this.workflowData.TransferType, "pull")
                ? true
                : this.workflowData.DeleteFiles == true
                    ? true
                    : false;
            await this.addWorkflowToDb(this.workflow);
        }
    }
    async addWorkflowToDb(request) {
        this.apiLoading = true;
        try {
            const response = await postRequest<WorkflowType>(Apis.ADD_WORKFLOW_CLONE, request);
            if (response?.messageStatus === null) {
                showToast({
                    message: "A new workflow has been created successfully.",
                    role: "success",
                    duration: GlobalVariables.TOAST_TIMEOUT,
                });
                const router = new Router(routerConfig);
                router.go("/workflows");
            } else if (response?.details?.length > 0) {
                const errMsg = getWorkflowSaveErrorMessage(response.details);
                showToast({
                    message: errMsg,
                    role: "danger",
                    duration: GlobalVariables.TOAST_TIMEOUT,
                });
            } else {
                showToast({
                    message: "Something went wrong, please try again.",
                    role: "danger",
                    duration: GlobalVariables.TOAST_TIMEOUT,
                });
            }
        } finally {
            this.apiLoading = false;
        }
    }
    async getData(workflowId: string) {
        return await getRequest(Apis.GET_WORKFLOW_CLONE + `/` + fixedEncodeURIComponent(workflowId));
    }
    @property()
    pageTitle = "Clone Workflow";
    async connectedCallback() {
        this.apiLoading = true;
        this.activeTab = "";
        const bucketNameStart = "/";
        super.connectedCallback();
        try {
            const workData = await this.getData(this.workflowId);
            if (!workData || workData instanceof Response) {
                abortWorkflowLoad(workData);
                return;
            }
            document.title = document.title.concat(" >", this.pageTitle);
            // this.bucketName = bucketNameStart.concat(workData.sourceLocationPath.substring(1, workData.sourceLocationPath.indexOf('/', workData.sourceLocationPath.indexOf('/') + 1)));
            // this.sourcePath = workData.sourceLocationPath.replace(workData.sourceLocationPath.substring(0, workData.sourceLocationPath.indexOf('/', workData.sourceLocationPath.indexOf('/') + 1)), "");
            this.businessUnit = workData.businessUnitParticipant.toLowerCase();
            this.setWorkflowData(workData);
            this.setNotificationData(workData);
            this.setSchedulerData(workData);
            this.setWorkflowStepsData(workData);
            this.setFilePatternData(workData);
            this.activeTab = "page1";
            // Form is interactive once the spinner clears. Capture before General Info
            // lookups; fold the BU auto-fill after — do not recapture live form state.
            this._cancelBaseline = captureWorkflowCancelBaseline(this.cancelSnapshotInput());
            this.apiLoading = false;
            await this.updateComplete;
            await afterGeneralInfoLoad(this);
            this.foldGeneralInfoDefaults();
        } finally {
            this.apiLoading = false;
        }
    }
    private cancelSnapshotInput() {
        return {
            workflowData: this.workflowData,
            filepattern: this.filepattern,
            notification: this.notification,
            steps: this.steps,
            schedulerData: this.schedulerData,
        };
    }
    /**
     * Fold the Business Admin BU auto-fill once GI lookups have landed.
     * Call from Cancel as well as after load — do not recapture live form state.
     */
    private foldGeneralInfoDefaults() {
        if (this._giDefaultsFolded) return;
        const gi = this.shadowRoot?.querySelector("workflow-general-info") as
            | {
                lookupsDone?: boolean;
                autoFilledBusinessUnitParticipant?: string;
            }
            | null
            | undefined;
        const { lookupsDone, autoFilled: filled } = resolveGeneralInfoAutoFill(this.workflowData, gi);
        if (!lookupsDone) return;
        this._giDefaultsFolded = true;
        if (filled !== undefined) {
            this._cancelBaseline = applyWorkflowCancelBaselineDefaults(this._cancelBaseline, {
                workflowData: { BusinessUnitParticipant: filled },
            });
        }
    }
    /** ACME-1050: true only after real user edits vs hydrate baseline. */
    private hasUnsavedChanges(): boolean {
        this.foldGeneralInfoDefaults();
        return isWorkflowCancelDirty(this._cancelBaseline, this.cancelSnapshotInput());
    }
    setWorkflowData(workData: any) {
        const isEnterpriseAdmin = stringComparison(
            decryptValue(Cookies.get("userType") || ""),
            "EnterpriseAdmin",
        );
        this.workflowData.BusinessUnitParticipant = isEnterpriseAdmin
            ? ""
            : String(Cookies.get("businessUnit") || workData.businessUnitParticipant || "").toLowerCase();
        this.workflowData.TransferType = workData.transferType;
        this.workflowData.WorkflowName = "";
        this.workflowData.WorkflowId = newWorkflowId();
        this.workflowData.sourceLocationPath = "";
        this.workflowData.isClone = true;
        this.workflowData.DeleteFiles = workData.deleteFiles;
        syncGeneralInfoValid(this.workflowData);
    }
    setNotificationData(workData: any) {
        this.notification = Array.isArray(workData?.notification) ? workData.notification : [];
        this.notification.forEach((element: any, index: Number) => {
            element.number = index + 1;
            element.added = false;
            element.to = element.to ?? element.To ?? "";
            element.subject = element.subject ?? element.Subject ?? "";
            element.template = element.template ?? element.Template ?? "";
            element.messageType = element.messageType ?? element.MessageType ?? "";
            element.notificationType = element.notificationType ?? element.NotificationType ?? "";
        });
    }
    setSchedulerData(workData: any) {
        if (workData.scheduler != undefined) {
            this.schedulerData = workData.scheduler;
            this.schedulerData.SchedulerName = workData.scheduler.schedulerName;
            this.schedulerData.Description = workData.scheduler.description;
            this.schedulerData.Expression = workData.scheduler.expression;
            if (workData.scheduler.timezone) {
                let currentDateTime = getCurrentDateTimeInTimeZone(getTimeZoneIdentifier(workData.scheduler.timezone));
                if (currentDateTime) {
                    currentDateTime = new Date(currentDateTime.getTime() + 60 * 60 * 1000);
                    this.schedulerData.StartDate = `${currentDateTime.getFullYear()}-${String(currentDateTime.getMonth() + 1).padStart(
                        2,
                        "0"
                    )}-${String(currentDateTime.getDate()).padStart(2, "0")}`;
                    this.schedulerData.StartTime = currentDateTime.toTimeString().split(" ")[0];
                }
                if (this.schedulerData.StartTime) {
                    const [hour, minute] = this.schedulerData.StartTime.split(":");
                    this.schedulerData.StartHour = hour;
                    this.schedulerData.StartMinute = minute;
                }
            }
            this.schedulerData.EndDate = workData.scheduler.endDate;
            this.schedulerData.EndTime = workData.scheduler.endTime;
            this.schedulerData.TimeZone = workData.scheduler.timezone;
            this.schedulerData.valid = false;
            this.schedulerData.isEdit = true;
        }
    }
    setWorkflowStepsData(workData: any) {
        if (workData.workflowSteps.length > 0) {
            let workflowSteps = {
                FunctionName: "",
                StepName: "",
                DeleteSourceFile: false,
                FileMovePattern: [],
                DestinationFileInfo: {
                    Name: "",
                    Path: "",
                    LocationType: "",
                    StorageType: "",
                    FileRename: [],
                    BucketRename: "",
                    secretName: "",
                    secretValue: {},
                },
                SourceFileInfo: {
                    Name: "",
                    Path: "",
                    LocationType: "",
                    StorageType: "",
                    FileRename: [],
                    BucketRename: "",
                    secretName: "",
                    secretValue: {},
                },
                StepIndex: 0,
            };

            this.steps = [];
            if (stringComparison(this.workflowData.TransferType, "PUSH")) {
                if (workData.workflowSteps[0].stepName == "rulechecker") {
                    workData.workflowSteps.splice(0, 1);
                    for (let i = 0; i < workData.workflowSteps.length; i++) {
                        workData.workflowSteps[i].stepIndex = workData.workflowSteps[i].stepIndex - 1;
                    }
                }
                for (let i = 0; i < workData.workflowSteps.length; i++) {
                    this.steps.push(JSON.parse(JSON.stringify(workflowSteps)));
                    this.steps[i].stepName = workData.workflowSteps[i].stepName;
                    if (stringComparison(workData.workflowSteps[i].stepName, "unprocessedfilearchive")) {
                        this.steps[i].functionName = workData.workflowSteps[i].stepName.toString().toLowerCase();
                    } else {
                        this.steps[i].functionName = workData.workflowSteps[i].functionName;
                    }
                    this.steps[i].deleteSourceFile = stringComparison(workData.workflowSteps[i].deleteSourceFile, false) ? "false" : "true";
                    this.steps[i].FileMovePattern = workData.workflowSteps[i].fileMovePattern;
                    this.steps[i].stepIndex = workData.workflowSteps[i].stepIndex + 1;
                    this.steps[i].institutionUuid = readInstitutionUuidFromStep(
                        workData.workflowSteps[i]
                    );
                    if (stringComparison(this.steps[i].functionName, "filedelete")) {
                        this.steps[i].name = workData.workflowSteps[i].sourceFileInfo.name;
                        this.steps[i].path = stringComparison(workData.workflowSteps[i].sourceFileInfo.storageType, "amazons3")
                            ? workData.workflowSteps[i].sourceFileInfo.path.replace(this.workflowData.BusinessUnitParticipant + "/", "")
                            : workData.workflowSteps[i].sourceFileInfo.path;
                        this.sourceFolder = workData.workflowSteps[i].sourceFileInfo.name;
                        this.steps[i].locationType = workData.workflowSteps[i].sourceFileInfo.locationType;
                        this.steps[i].storageType = workData.workflowSteps[i].sourceFileInfo.storageType;
                        this.steps[i].fileRename = workData.workflowSteps[i].sourceFileInfo.fileRename;
                        this.steps[i].bucketRename = workData.workflowSteps[i].sourceFileInfo.bucketRename;
                        if (this.steps[i].storageType == "azure" || this.steps[i].storageType == "amazons3remote") {
                            this.steps[i].secretName = workData.workflowSteps[i].destinationFileInfo.secretName;
                            this.steps[i].secretValue = workData.workflowSteps[i].destinationFileInfo.secretValue;
                        } else {
                            this.steps[i].secretName = workData.workflowSteps[i].sourceFileInfo.secretName;
                            this.steps[i].secretValue = workData.workflowSteps[i].sourceFileInfo.secretValue;
                        }
                    } else {
                        this.steps[i].name = workData.workflowSteps[i].destinationFileInfo.name;
                        this.steps[i].path =
                            stringComparison(workData.workflowSteps[i].destinationFileInfo.storageType, "amazons3") &&
                                !stringComparison(this.steps[i].functionName.toLowerCase(), "unprocessedfilearchive")
                                ? workData.workflowSteps[i].destinationFileInfo.path.replace(this.workflowData.BusinessUnitParticipant, "")
                                : workData.workflowSteps[i].destinationFileInfo.path;
                        this.steps[i].locationType = workData.workflowSteps[i].destinationFileInfo.locationType;
                        this.steps[i].storageType = workData.workflowSteps[i].destinationFileInfo.storageType;
                        this.steps[i].fileRename = workData.workflowSteps[i].destinationFileInfo.fileRename;
                        this.steps[i].bucketRename = workData.workflowSteps[i].destinationFileInfo.bucketRename;
                        if (this.steps[i].storageType == "azure" || this.steps[i].storageType == "amazons3remote") {
                            this.steps[i].secretName = workData.workflowSteps[i].destinationFileInfo.secretName;
                            this.steps[i].secretValue = workData.workflowSteps[i].destinationFileInfo.secretValue;
                        } else {
                            this.steps[i].secretName = workData.workflowSteps[i].sourceFileInfo.secretName;
                            this.steps[i].secretValue = workData.workflowSteps[i].sourceFileInfo.secretValue;
                        }
                    }
                    syncStepAuthTypesFromBothFileInfos(
                        this.steps[i],
                        workData.workflowSteps[i].sourceFileInfo,
                        workData.workflowSteps[i].destinationFileInfo
                    );
                    this.steps[i].isValidStep = this.validateWorkflowStep(this.steps[i]);
                    if (!this.steps[i].isValidStep) {
                        this.isWorkflowStepsValid = false;
                    }
                    this.steps[i].path =
                        this.steps[i].path && this.steps[i].path != "" && !this.steps[i].path.startsWith("/")
                            ? "/" + this.steps[i].path
                            : this.steps[i].path;
                }
            } else if (stringComparison(this.workflowData.TransferType, "PULL")) {
                for (let i = 0; i < workData.workflowSteps.length; i++) {
                    this.steps.push(JSON.parse(JSON.stringify(workflowSteps)));
                    this.steps[i].stepName = workData.workflowSteps[i].stepName;
                    if (stringComparison(workData.workflowSteps[i].stepName, "unprocessedfilearchive")) {
                        this.steps[i].functionName = workData.workflowSteps[i].stepName.toString().toLowerCase();
                    } else {
                        this.steps[i].functionName = workData.workflowSteps[i].functionName;
                    }
                    this.steps[i].deleteSourceFile = stringComparison(workData.workflowSteps[i].deleteSourceFile, false) ? "false" : "true";
                    this.steps[i].FileMovePattern = workData.workflowSteps[i].fileMovePattern;
                    this.steps[i].stepIndex = workData.workflowSteps[i].stepIndex;
                    this.steps[i].institutionUuid = readInstitutionUuidFromStep(
                        workData.workflowSteps[i]
                    );
                    if (
                        stringComparison(this.steps[i].functionName, "filedownload") ||
                        stringComparison(this.steps[i].functionName, "filedelete")
                    ) {
                        this.steps[i].name = workData.workflowSteps[i].sourceFileInfo.name;
                        this.steps[i].path = stringComparison(workData.workflowSteps[i].sourceFileInfo.storageType, "amazons3")
                            ? workData.workflowSteps[i].sourceFileInfo.path.replace(this.workflowData.BusinessUnitParticipant, "")
                            : workData.workflowSteps[i].sourceFileInfo.path;
                        this.sourceFolder = workData.workflowSteps[i].sourceFileInfo.name;
                        this.steps[i].locationType = workData.workflowSteps[i].sourceFileInfo.locationType;
                        this.steps[i].storageType = workData.workflowSteps[i].sourceFileInfo.storageType;
                        this.steps[i].fileRename = workData.workflowSteps[i].sourceFileInfo.fileRename;
                        this.steps[i].bucketRename = workData.workflowSteps[i].sourceFileInfo.bucketRename;

                        this.steps[i].secretName = workData.workflowSteps[i].sourceFileInfo.secretName;
                        this.steps[i].secretValue = workData.workflowSteps[i].sourceFileInfo.secretValue;
                    } else {
                        this.steps[i].name = workData.workflowSteps[i].destinationFileInfo.name;
                        this.steps[i].path = stringComparison(workData.workflowSteps[i].destinationFileInfo.storageType, "amazons3")
                            ? workData.workflowSteps[i].destinationFileInfo.path.replace(this.workflowData.BusinessUnitParticipant, "")
                            : workData.workflowSteps[i].destinationFileInfo.path;
                        this.steps[i].locationType = workData.workflowSteps[i].destinationFileInfo.locationType;
                        this.steps[i].storageType = workData.workflowSteps[i].destinationFileInfo.storageType;
                        this.steps[i].fileRename = workData.workflowSteps[i].destinationFileInfo.fileRename;
                        this.steps[i].bucketRename = workData.workflowSteps[i].destinationFileInfo.bucketRename;
                        if (this.steps[i].storageType == "azure" || this.steps[i].storageType == "amazons3remote") {
                            this.steps[i].secretName = workData.workflowSteps[i].destinationFileInfo.secretName;
                            this.steps[i].secretValue = workData.workflowSteps[i].destinationFileInfo.secretValue;
                        } else {
                            this.steps[i].secretName = workData.workflowSteps[i].sourceFileInfo.secretName;
                            this.steps[i].secretValue = workData.workflowSteps[i].sourceFileInfo.secretValue;
                        }
                    }
                    syncStepAuthTypesFromBothFileInfos(
                        this.steps[i],
                        workData.workflowSteps[i].sourceFileInfo,
                        workData.workflowSteps[i].destinationFileInfo
                    );
                    this.steps[i].isValidStep = this.validateWorkflowStep(this.steps[i]);
                    if (!this.steps[i].isValidStep) {
                        this.isWorkflowStepsValid = false;
                    }
                    this.steps[i].path =
                        this.steps[i].path && !this.steps[i].path.startsWith("/") ? "/" + this.steps[i].path : this.steps[i].path;
                }
            }
        } else {
            this.steps = [];
        }
    }
    setFilePatternData(workData: any) {
        let regexPattern = "\\/*";
        this.filepattern.DataFilePattern = stringComparison(workData.transferType, "push")
            ? workData.dataFilePattern
            : workData.dataFilePattern.map((element) => element.replace(regexPattern, "").replace("\\/", "/"));
        this.filepattern.TriggerFilePattern = stringComparison(workData.transferType, "push")
            ? workData.triggerFilePattern
            : workData.triggerFilePattern.map((element) => element.replace(regexPattern, "").replace("\\/", "/"));
    }
    validateWorkflowStep(step: any): boolean {
        const st = String(step.storageType ?? "").toLowerCase();
        if (
            step.stepName?.trim() &&
            step.functionName?.trim() &&
            step.locationType?.trim() &&
            step.storageType?.trim() &&
            (((step.bucketRename === undefined || step.bucketRename === "") && step.name?.trim()) || step.bucketRename?.trim()) &&
            (step.path?.trim() || st === "ftps" || st === "sftp") &&
            (((st === "ftps" || st === "sftp") && wizardStepSftpFtpsSecretsComplete(step)) ||
                (step.functionName === "fileencrypt" && step.secretValue?.PGPKey?.trim()) ||
                (step.storageType === "azure" && step.secretValue?.ConnectionString?.trim()) ||
                (step.storageType !== "ftps" &&
                    step.storageType !== "sftp" &&
                    step.functionName !== "fileencrypt" &&
                    step.storageType !== "azure"))
        ) {
            return true;
        } else {
            return false;
        }
    }
    onBackClick() {
        const router = new Router(routerConfig);
        router.go("/workflows");
    }
    async onCancelClick() {
        if (this.isReadOnlyUser) {
            AppRouters.go("/workflows");
            return;
        }
        // No change → no prompt (ACME-1050). Do not remove this gate.
        if (!this.hasUnsavedChanges()) {
            AppRouters.go("/workflows");
            return;
        }
        const result = await openJhftDialog({
            variant: "warning",
            title: "Unsaved Changes",
            message: "You have unsaved changes. Are you sure you want to leave without saving?",
            cancelLabel: "Stay",
            confirmLabel: "Leave Without Saving",
        });
        if (result === "confirm") {
            AppRouters.go("/workflows");
        }
    }

    onSaveWorkflowPatternsEvent(e) {
        this.isFilePatternValid = e?.detail?.DataFilePattern.length > 0 && e?.detail?.TriggerFilePattern.length > 0;
    }
    render() {
        return html`
      ${this.apiLoading ? html`<circle-loader></circle-loader>` : undefined}
      <div id="cloneWorkflowTab">
        <h1>
          <span>Clone Workflow</span>
        </h1>
        <jha-card>
          <jha-tab bordered>
            <jha-tab-item
              data-auto-id="generalInfoTab"
              ?active=${stringComparison(this.activeTab, "page1")}
              @click=${() => {
                this.activeTab = "page1";
                this.workFlowDisable = false;
            }}>
              General
              Information${isGeneralInfoTabComplete(this.workflowData)
                ? html`<jha-icon-circle-checkmark-filled icon></jha-icon-circle-checkmark-filled>`
                : html` <jha-icon-warning-filled icon></jha-icon-warning-filled> `}
            </jha-tab-item>
            <jha-tab-item
              data-auto-id="filePatternTab"
              ?active=${stringComparison(this.activeTab, "page2")}
              @click=${() => {
                this.activeTab = "page2";
                this.workFlowDisable = false;
            }}>
              File
              Patterns${this.isFilePatternValid
                ? html`<jha-icon-circle-checkmark-filled icon></jha-icon-circle-checkmark-filled>`
                : html` <jha-icon-warning-filled icon></jha-icon-warning-filled> `}
            </jha-tab-item>
            <jha-tab-item
              data-auto-id="notificationTab"
              ?active=${stringComparison(this.activeTab, "page3")}
              @click=${() => {
                this.activeTab = "page3";
                this.workFlowDisable = false;
            }}>
              Notifications
            </jha-tab-item>
            <jha-tab-item
              data-auto-id="workflowStepsTab"
              ?active=${stringComparison(this.activeTab, "page4")}
              @click=${() => {
                this.activeTab = "page4";
                this.workFlowDisable = false;
            }}>
              Workflow Steps${this.isWorkflowStepsValid
                ? html`<jha-icon-circle-checkmark-filled icon></jha-icon-circle-checkmark-filled>`
                : html` <jha-icon-warning-filled icon></jha-icon-warning-filled> `}
            </jha-tab-item>
            ${stringComparison(this.workflowData.TransferType, "PULL")
                ? html` <jha-tab-item
                  data-auto-id="schedulerTab"
                  ?active=${stringComparison(this.activeTab, "page5")}
                  @click=${() => {
                        this.activeTab = "page5";
                        this.workFlowDisable = false;
                    }}>
                  Scheduler${this.isSchedulerValid
                        ? html`<jha-icon-circle-checkmark-filled icon></jha-icon-circle-checkmark-filled>`
                        : html` <jha-icon-warning-filled icon></jha-icon-warning-filled> `}
                </jha-tab-item>`
                : undefined}
          </jha-tab>
          <div id="tabContent">
            ${stringComparison(this.activeTab, "page1")
                ? html`<workflow-general-info
                  @onWorkflowNameChange=${this.onSaveWorkflowCustomEvent}
                  .formData=${this.workflowData}></workflow-general-info>`
                : undefined}
            ${stringComparison(this.activeTab, "page2")
                ? html`<file-pattern-view
                  @onFilePatternChange=${this.onSaveWorkflowPatternsEvent}
                  .formData=${this.filepattern}></file-pattern-view>`
                : undefined}
            ${stringComparison(this.activeTab, "page3")
                ? html`<notification-view
                  @onformNotValid=${this.unsavednotificationChanges}
                  .formData=${this.notificationData}
                  @onNotificationChange=${this.onSaveNotificationCustomEvent}
                  .notificationList=${this.notification}></notification-view>`
                : undefined}
            ${stringComparison(this.activeTab, "page4")
                ? html`<workflow-steps-view
                  @onStepsChange=${this.onSaveStepsCustomEvent}
                  .formData=${this.workflowData}
                  .workflowStepsData=${this.steps}>
                </workflow-steps-view>`
                : undefined}
            ${stringComparison(this.activeTab, "page5") && stringComparison(this.workflowData.TransferType, "PULL")
                ? html`<p><scheduler-view @onSchedulerChange=${this.onSaveSchedulerEvent} .formData=${this.schedulerData} /></p>`
                : undefined}
          </div>
          <div id="actionBtns" style="margin-top:5%;">
            ${!this.isReadOnlyUser
                ? html`
                  <jha-tooltip top text="Click to save the workflow details.">
                    <jha-button
                      data-auto-id="saveBtn"
                      @click=${this.onCloneWorkflowClick}
                      sync
                      ?disabled=${!this.hasUnsavedChanges() ||
                    !(
                        isGeneralInfoTabComplete(this.workflowData) &&
                        this.isWorkflowStepsValid &&
                        (this.isSchedulerValid === undefined || this.isSchedulerValid === true)
                    )}>
                      Save Workflow
                    </jha-button>
                  </jha-tooltip>
                `
                : undefined}
            <jha-tooltip top text="Click to cancel and exit back to the workflows page.">
              <jha-button data-auto-id="cancelBtn" tertiary sync @click=${this.onCancelClick}>Cancel</jha-button>
            </jha-tooltip>
          </div>
        </jha-card>
      </div>
    `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "clone-workflow-tab-view": CloneWorkflowTabView;
    }
}
